import { jsxs as r, jsx as l } from "react/jsx-runtime";
import { forwardRef as u } from "react";
const b = u(function({
  sidebar: e,
  main: c,
  aside: n,
  banner: o,
  skipTargetId: s = "main-content",
  skipLinkLabel: i = "a11y.skipToContent",
  asideLabel: t = "a11y.contextRail",
  className: a,
  children: h,
  ...d
}, f) {
  return /* @__PURE__ */ r(
    "div",
    {
      ref: f,
      "data-component": "AppShell",
      className: (
        // Three-area layout: sidebar | content-stack | aside (if present).
        // Flex keeps the columns deterministic; tokens drive every value.
        "ls-app-shell relative flex min-h-[100vh] w-full bg-bg-base text-primary" + (a ? " " + a : "")
      ),
      ...d,
      children: [
        /* @__PURE__ */ l(
          "a",
          {
            href: `#${s}`,
            className: "ls-focus-ring sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-modal focus:rounded-md focus:bg-bg-surface focus:px-3 focus:py-2 focus:text-sm focus:text-primary",
            children: i
          }
        ),
        e ? /* @__PURE__ */ l("div", { "data-region": "sidebar", className: "hidden shrink-0 lg:block", children: e }) : null,
        /* @__PURE__ */ r("div", { "data-region": "content-stack", className: "flex min-w-0 flex-1 flex-col", children: [
          o ? /* @__PURE__ */ l("div", { "data-region": "banner", className: "w-full", children: o }) : null,
          /* @__PURE__ */ l("main", { id: s, tabIndex: -1, className: "ls-focus-ring min-w-0 flex-1 outline-none", children: c })
        ] }),
        n ? /* @__PURE__ */ l(
          "aside",
          {
            "data-region": "aside",
            "aria-label": t,
            className: "hidden w-[320px] shrink-0 border-l border-subtle bg-bg-surface xl:block",
            children: n
          }
        ) : null
      ]
    }
  );
});
export {
  b as A
};
//# sourceMappingURL=AppShell-DLMfK0m8.js.map
